import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Image from 'components/Image';
import Head from 'components/Head';
import { getMeta } from 'constants/meta';

const PATHNAME = '/404';

const Error404 = () => {
  const { title, description } = getMeta(PATHNAME);
  return (
    <Fragment>
      <Head title={title} description={description} />
      <div className="error-404">
        <div className="error-404__wrapper">
          <header className="error-404__header">
            <Link className="error-404__logo" to="/">
              <Image src="logo-404.svg" />
            </Link>
            <Link to="/login" className="link error-404__login-link">
              Login
            </Link>
          </header>
          <section className="error-404__content">
            <div className="error-404__title">404</div>
            <div className="error-404__subtitle">Page Not Found</div>
            <div className="error-404__text">
              The page you're looking for cannot be found.
            </div>
            <Link to="/" className="link error-404__back-link">
              Back to Homepage
            </Link>
          </section>
          <footer className="error-404__footer">
            Copyright &#169; 2025 Siteplus, Pte Ltd. All rights reserved.{' '}
            <span className="error-404__footer-link-wrap">
              <Link
                to="/legal/terms"
                className="link error-404__footer-link"
                target="_blank"
              >
                Terms of Service
              </Link>
              {' | '}
              <Link
                to="/legal/privacy"
                className="link error-404__footer-link"
                target="_blank"
              >
                Privacy Policy
              </Link>
              {' | '}
              <Link
                to="/legal/gdpr"
                className="link error-404__footer-link"
                target="_blank"
              >
                GDPR
              </Link>
              .
            </span>
          </footer>
        </div>
      </div>
    </Fragment>
  );
};

export default Error404;
